module.exports = __webpack_public_path__ + "static/img/evaluation_success.a3f8666.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/basic/card/img/evaluation_success.png
// module id = dpZe
// module chunks = 1